<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="24"
    height="24"
    viewBox="0 0 172 172"
    style="fill: #ffffff"
  >
    <defs>
      <radialGradient
        cx="85.99463"
        cy="84.65625"
        r="82.7105"
        gradientUnits="userSpaceOnUse"
        id="color-1_fQDK2sCN4Eh1_gr1"
      >
        <stop offset="0" stop-color="#262d31"></stop>
        <stop offset="0.219" stop-color="#262d31"></stop>
        <stop offset="0.644" stop-color="#262d31"></stop>
        <stop offset="1" stop-color="#262d31"></stop>
      </radialGradient>
      <linearGradient
        x1="79.01519"
        y1="166.453"
        x2="79.01519"
        y2="-109.47262"
        gradientUnits="userSpaceOnUse"
        id="color-2_fQDK2sCN4Eh1_gr2"
      >
        <stop offset="0" stop-color="#ff5840"></stop>
        <stop offset="0.007" stop-color="#ff5840"></stop>
        <stop offset="0.989" stop-color="#fa528c"></stop>
        <stop offset="1" stop-color="#fa528c"></stop>
      </linearGradient>
      <linearGradient
        x1="32.64775"
        y1="175.0315"
        x2="32.64775"
        y2="48.88025"
        gradientUnits="userSpaceOnUse"
        id="color-3_fQDK2sCN4Eh1_gr3"
      >
        <stop offset="0" stop-color="#feaa53"></stop>
        <stop offset="0.612" stop-color="#ffcd49"></stop>
        <stop offset="1" stop-color="#ffde44"></stop>
      </linearGradient>
      <linearGradient
        x1="79.98"
        y1="90.97456"
        x2="79.98"
        y2="196.02356"
        gradientUnits="userSpaceOnUse"
        id="color-4_fQDK2sCN4Eh1_gr4"
      >
        <stop offset="0" stop-color="#42d778"></stop>
        <stop offset="0.428" stop-color="#3dca76"></stop>
        <stop offset="1" stop-color="#34b171"></stop>
      </linearGradient>
      <linearGradient
        x1="123.625"
        y1="167.59788"
        x2="123.625"
        y2="81.71881"
        gradientUnits="userSpaceOnUse"
        id="color-5_fQDK2sCN4Eh1_gr5"
      >
        <stop offset="0" stop-color="#155cde"></stop>
        <stop offset="0.278" stop-color="#1f7fe5"></stop>
        <stop offset="0.569" stop-color="#279ceb"></stop>
        <stop offset="0.82" stop-color="#2cafef"></stop>
        <stop offset="1" stop-color="#2eb5f0"></stop>
      </linearGradient>
    </defs>
    <g
      fill="none"
      fill-rule="nonzero"
      stroke="none"
      stroke-width="1"
      stroke-linecap="butt"
      stroke-linejoin="miter"
      stroke-miterlimit="10"
      stroke-dasharray=""
      stroke-dashoffset="0"
      font-family="none"
      font-weight="none"
      font-size="none"
      text-anchor="none"
      style="mix-blend-mode: normal"
    >
      <path d="M0,172v-172h172v172z" fill="none"></path>
      <g>
        <path
          d="M171.91938,80.78625c-0.77938,7.68625 -7.68625,13.27625 -15.39937,13.27625h-14.0825c-3.27875,0 -5.85875,2.9025 -5.29438,6.28875c0.43,2.63375 2.9025,4.46125 5.59,4.46125h9.11062c7.06813,0 12.76563,6.1275 12.04,13.33c-0.645,6.28875 -6.28875,10.8575 -12.60438,10.8575h-14.21687c-3.27875,0 -5.85875,2.9025 -5.29438,6.28875c0.43,2.63375 2.9025,4.46125 5.59,4.46125h9.11062c3.3325,0 6.36937,1.34375 8.54625,3.5475c2.20375,2.17687 3.5475,5.21375 3.5475,8.54625c0,6.69188 -5.40187,12.09375 -12.09375,12.09375h-118.25c-4.085,0 -7.79375,-1.66625 -10.45438,-4.32688c-2.66062,-2.66063 -4.32687,-6.36937 -4.32687,-10.45437c0,-8.17 6.61125,-14.78125 14.78125,-14.78125h9.40625c3.27875,0 5.85875,-2.9025 5.29438,-6.28875c-0.43,-2.63375 -2.9025,-4.46125 -5.59,-4.46125h-22.54812c-7.06812,0 -12.76562,-6.1275 -12.04,-13.33c0.645,-6.28875 6.28875,-10.8575 12.60438,-10.8575h19.59188c4.59563,0 8.30438,-3.84313 8.0625,-8.4925c-0.24188,-4.35375 -4.16562,-7.6325 -8.51937,-7.6325h-22.38688c-7.06812,0 -12.76562,-6.1275 -12.04,-13.33c0.645,-6.28875 6.31563,-10.8575 12.60438,-10.8575h26.31063c3.3325,0 6.36938,-1.34375 8.54625,-3.5475c2.20375,-2.17687 3.5475,-5.21375 3.5475,-8.54625c0,-6.69188 -5.40187,-12.09375 -12.09375,-12.09375h-16.125c-4.085,0 -7.79375,-1.66625 -10.45438,-4.32687c-2.66062,-2.66063 -4.32687,-6.36938 -4.32687,-10.45438c0,-8.17 6.61125,-14.78125 14.78125,-14.78125h129c8.62688,0 15.5875,7.49813 14.70063,16.28625c-0.77938,7.68625 -4.99875,13.27625 -12.71187,13.27625h-4.67625c-8.17,0 -14.78125,6.61125 -14.78125,14.78125c0,4.085 1.66625,7.79375 4.32688,10.45437c2.66063,2.66062 6.36937,4.32688 10.45437,4.32688h8.0625c8.62688,0 15.5875,7.49813 14.70063,16.28625z"
          fill="url(#color-1_fQDK2sCN4Eh1_gr1)"
        ></path>
        <path
          d="M127.54875,41.65625l-3.68187,3.9775c-3.60125,3.87 -9.40625,4.48812 -13.84062,1.6125c-7.28313,-4.70312 -17.28062,-8.41187 -29.5625,-6.36937c-13.27625,2.23062 -24.64438,10.34688 -31.2825,21.41937l-21.58062,-16.34c12.685,-19.565 34.74937,-32.51875 59.74312,-32.51875c13.4375,0 26.71375,4.1925 38.35062,11.98625c5.4825,3.68187 6.3425,11.42188 1.85438,16.2325z"
          fill="url(#color-2_fQDK2sCN4Eh1_gr2)"
        ></path>
        <path
          d="M43.02688,83.07063c-0.24188,6.63813 0.99438,12.98063 3.41313,18.705l-22.06438,16.25937c-3.62812,-6.74562 -6.18125,-14.19 -7.39062,-22.09125c-2.84875,-18.49 1.45125,-35.95875 10.61562,-49.9875l21.58062,16.34c-3.68187,6.15438 -5.9125,13.24938 -6.15437,20.77438z"
          fill="url(#color-3_fQDK2sCN4Eh1_gr3)"
        ></path>
        <path
          d="M135.58438,137.815c-12.22812,10.93813 -28.51437,17.65688 -46.655,18.03313c-27.35875,0.56437 -52.21813,-14.67375 -64.55375,-37.81312l22.06438,-16.25937c6.71875,15.96375 22.54813,27.22437 40.90375,27.22437c10.58875,0 20.21,-3.44 27.76187,-9.245z"
          fill="url(#color-4_fQDK2sCN4Eh1_gr4)"
        ></path>
        <path
          d="M158.5625,85.91938c0.02687,20.77438 -8.76125,39.18375 -22.97813,51.89563l-20.47875,-18.06c5.64375,-4.32688 10.13188,-9.97063 13.0075,-16.52813c0.77938,-1.77375 -0.5375,-3.78937 -2.4725,-3.78937h-26.20312c-5.93937,0 -10.75,-4.81062 -10.75,-10.75v-5.375c0,-5.93937 4.81063,-10.75 10.75,-10.75h45.6875c7.39063,0 13.4375,5.96625 13.4375,13.35687z"
          fill="url(#color-5_fQDK2sCN4Eh1_gr5)"
        ></path>
      </g>
    </g>
  </svg>
</template>